export const HELP_CATEGORIES = [
  {
    flags: ['show_accounts_widget_in_master'],
    guid: 'accounts',
    icon: 'account_balance',
    title: 'Accounts',
    topics: [
      {
        topicKey: 'accounts-overview',
      },
      {
        topicKey: 'trouble-adding-an-account',
      },
      {
        topicKey: 'need-to-fix-a-broken-account',
      },
      {
        topicKey: 'seeing-outdated-accounts-or-paid-off-loans',
      },
      {
        topicKey: 'seeing-duplicate-accounts',
      },
    ],
  },
  {
    flags: ['show_transactions_widget_in_master'],
    guid: 'transactions',
    icon: 'receipt_long',
    title: 'Transactions',
    topics: [
      {
        topicKey: 'transactions-overview',
      },
      {
        topicKey: 'seeing-duplicate-transactions',
      },
      {
        topicKey: 'missing-transactions',
      },
      {
        topicKey: 'pending-transactions',
      },
      {
        topicKey: 'exporting-transactions',
      },
    ],
  },
  {
    flags: ['show_spending_widget_in_master'],
    guid: 'spending',
    icon: 'donut_small',
    title: 'Spending',
    topics: [
      {
        topicKey: 'spending-widget-overview',
      },
      {
        topicKey: 'not-seeing-all-spending-categories',
      },
      {
        topicKey: 'spending-categories-seem-inaccurate',
      },
    ],
  },
  {
    flags: ['show_budgets_widget_in_master'],
    guid: 'budgets',
    icon: 'bubble_chart',
    title: 'Budgets',
    topics: [
      {
        topicKey: 'budgets-overview',
      },
    ],
  },
  {
    flags: ['show_trends_widget_in_master'],
    guid: 'trends',
    icon: 'multiline_chart',
    title: 'Trends',
    topics: [
      {
        topicKey: 'trends-overview',
      },
    ],
  },
  {
    flags: ['show_debts_widget_in_master'],
    guid: 'debts',
    icon: 'note_stack',
    title: 'Debts',
    topics: [
      {
        topicKey: 'debts-overview',
      },
    ],
  },
  {
    flags: ['show_net_worth_widget_in_master'],
    guid: 'networth',
    icon: 'elevation',
    title: 'Net Worth',
    topics: [
      {
        topicKey: 'net-worth-overview',
      },
    ],
  },
  {
    flags: ['show_goals_widget_in_master'],
    guid: 'goals',
    icon: 'trophy',
    title: 'Goals',
    topics: [
      {
        topicKey: 'goals-overview',
      },
    ],
  },
  {
    flags: ['show_cash_flow_widget_in_master'],
    guid: 'cashflow',
    icon: 'flowsheet',
    title: 'Cash Flow',
    topics: [
      {
        topicKey: 'cash-flow-overview',
      },
    ],
  },
  {
    flags: ['show_recurring_transactions_widget_in_master'],
    guid: 'recurring_transactions',
    icon: 'currency_exchange',
    title: 'Recurring Transactions',
    topics: [
      {
        label: 'Recurring Transactions Widget Overview',
        topicKey: 'overview',
      },
    ],
  },
  {
    flags: ['show_investments_widget_in_master'],
    guid: 'investments',
    icon: 'bid_landscape',
    title: 'Investments',
    topics: [
      {
        topicKey: 'investments-overview',
      },
    ],
  },
  {
    flags: ['show_notifications_widget_in_master'],
    guid: 'alerts',
    icon: 'account_balance',
    title: 'Alerts',
    topics: [
      {
        topicKey: 'notifications-overview',
      },
    ],
  },
  {
    guid: 'general',
    icon: 'info',
    title: 'General',
    topics: [
      {
        topicKey: 'is-my-data-private-and-secure',
      },
      {
        topicKey: 'why-are-some-of-my-transactions-uncategorized',
      },
      {
        topicKey: 'why-cant-i-see-the-software',
      },
      {
        topicKey: 'how-do-i-log-out-of-the-software',
      },
    ],
  },
  {
    guid: 'insights',
    icon: 'lightbulb',
    title: 'Insights',
    topics: [
      {
        topicKey: 'insights-widget-overview',
      },
    ],
  },
  {
    flags: ['display_mobile_devices_in_settings'],
    guid: 'mobile',
    icon: 'phone_iphone',
    title: 'Mobile',
    topics: [
      {
        topicKey: 'mobile-devices-overview',
      },
    ],
  },
]

export const HELP_CONTENT = {
  accounts: {
    guid: 'accounts',
    title: 'Accounts',
    topicTitle: 'Accounts Overview',
    content: {
      section1: {
        description:
          "FinTech Solutions is committed to revolutionizing the way individuals and businesses manage their finances. By providing an integrated platform of smart tools, we make it easier to track personal expenses, manage investments, and optimize business finances all in one place. Our innovative technology empowers users to make informed decisions, whether it's monitoring their spending, analyzing investment performance, or ensuring smooth cash flow for their business operations. With a focus on security, simplicity, and efficiency, FinTech Solutions helps users navigate the complexities of finance with confidence and clarity. Our platform is designed to be intuitive, scalable, and adaptable, allowing users to customize their financial strategies according to their unique needs, ensuring long-term growth and financial success.",
        image: 'https://assets.mx.com/images/company/careers/value-box-bg.png',
        title: 'Revolutionizing Financial Management',
      },
      section2: {
        description:
          "FinTech Solutions is committed to revolutionizing the way individuals and businesses manage their finances. By providing an integrated platform of smart tools, we make it easier to track personal expenses, manage investments, and optimize business finances all in one place. Our innovative technology empowers users to make informed decisions, whether it's monitoring their spending, analyzing investment performance, or ensuring smooth cash flow for their business operations. With a focus on security, simplicity, and efficiency, FinTech Solutions helps users navigate the complexities of finance with confidence and clarity.",
        image: 'https://assets.mx.com/images/company/careers/value-box-bg.png',
        listItems: [
          'Easily track expenses and manage personal finances.',
          'Easily track expenses and manage personal finances.',
          'Manage cash flow and financial operations in one platform.',
          'Ensure your financial data is protected with industry-leading security measures',
        ],
        listTitle: 'Effortless Financial Solutions',
        subDescription:
          'FinTech Solutions combines advanced technology with intuitive tools to make financial management easy for both individuals and businesses. Our platform offers everything from budgeting features to real-time insights, empowering users to take control of their financial future with confidence and security.',
        subTitle: 'Simplifying Financial Management',
        title: 'Empowering Financial Management',
      },
      section3: {
        description:
          'FinTech Solutions provides the tools and insights needed to make informed financial choices. From budgeting and investment tracking to comprehensive business financial management, our platform delivers real-time data and personalized recommendations. With a focus on ease of use and security, we help users navigate the complexities of finance and achieve their financial goals with confidence.',
        image: 'https://assets.mx.com/images/company/careers/value-box-bg.png',
        listItems: [
          'Track expenses, set budgets, and achieve savings goals.',
          'Monitor and analyze your investments with real-time updates.',
          'Streamline cash flow management and financial reporting.',
          'Protect your financial data with top-tier encryption and security protocols.',
        ],
        listTitle: 'Complete Financial Tools',
        title: 'Empowering Smarter Financial Decisions',
      },
      section4: {
        description:
          "FinTech Solutions simplifies managing your finances with powerful tools designed for both individuals and businesses. Whether you're tracking personal spending, optimizing investments, or streamlining business operations, our platform provides the insights and features you need to make confident financial decisions. With a focus on ease of use and data security, we help you stay in control of your financial future. Our innovative solutions offer real-time updates, personalized recommendations, and automated reporting, ensuring you're always in the know. Plus, with scalable features tailored to your needs, our platform grows with you, making it the ideal choice for anyone looking to take charge of their financial journey.",
        title: 'Seamless Financial Management',
      },
    },
  },
}

// TODO: Add more keys for additional logic
export const HELP_BY_CATEGORY_LIST = [
  {
    guid: 'personal_information',
    icon: 'person',
    topics: [
      {
        type: 'external',
      },
      {
        type: 'external',
      },
      {
        type: 'internal',
      },
      {
        type: 'external',
      },
    ],
  },
  {
    guid: 'money_movement',
    icon: 'currency_exchange',
    topics: [
      {
        type: 'external',
      },
      {
        type: 'external',
      },
      {
        type: 'external',
      },
      {
        type: 'external',
      },
    ],
  },
  {
    guid: 'institution',
    icon: 'account_balance',
    topics: [
      {
        type: 'external',
      },
      {
        type: 'other',
      },
      {
        type: 'internal',
      },
      {
        type: 'internal',
      },
    ],
  },
  {
    guid: 'transactions',
    icon: 'compare_arrows',
    topics: [
      {
        type: 'internal',
      },
      {
        type: 'external',
      },
      {
        type: 'internal',
      },
    ],
  },
]

// TODO: Add more keys for additional logic
export const POPULAR_TOPICS_LIST = [
  {
    type: 'external',
  },
  {
    type: 'external',
  },
  {
    type: 'external',
  },
  {
    type: 'external',
  },
  {
    type: 'other',
  },
  {
    type: 'internal',
  },
]
